import {
    CasinoGameTypeEnum,
    CasinoLayoutEnum,
    formatAppNameText,
    IRuntimeConfig,
} from "@finbackoffice/fe-core";
import { CasinoGameTag, HrefBehavior, AssetsDirectory } from "@finbackoffice/enums";
// import { CasinoScopesMap } from "@finbackoffice/site-core"; TODO import from site-core

export enum CasinoScopeEnum {
    LIVE_CASINO = "livecasino",
    SLOTS = "slots",
}

export const CasinoScopesMap: Record<CasinoScopeEnum, CasinoGameTypeEnum[]> = {
    [CasinoScopeEnum.SLOTS]: [
        CasinoGameTypeEnum.VIDEO_SLOTS,
        CasinoGameTypeEnum.TABLE_GAMES,
        CasinoGameTypeEnum.FAST_GAMES,
        CasinoGameTypeEnum.CRASH_GAMES,
        CasinoGameTypeEnum.VIDEO_BINGO,
        CasinoGameTypeEnum.VIDEO_POKER,
        CasinoGameTypeEnum.SCRATCH_CARDS,
        CasinoGameTypeEnum.VIRTUAL_GAMES,
        CasinoGameTypeEnum.VIRTUAL_SPORTS,
        CasinoGameTypeEnum.LIVE_GAMES,
    ],
    [CasinoScopeEnum.LIVE_CASINO]: [
        CasinoGameTypeEnum.LIVE_CASINO,
        CasinoGameTypeEnum.LIVE_CASINO_V2,
        CasinoGameTypeEnum.LIVE_CASINO_TABLE,
    ],
};

type GetCasinoGameImgSrcOptions = {
    showVideo?: boolean;
    imgVariant?: string;
    useAppName?: boolean;
    folder?: string;
};

export const getCasinoGameImgSrc = (
    runtimeConfig: IRuntimeConfig,
    gameId: string,
    gameType: CasinoGameTypeEnum,
    tags: CasinoGameTag[],
    options?: GetCasinoGameImgSrcOptions,
) => {
    let gameImgId = gameId.replace("-mobile", "");
    let dir = `/${AssetsDirectory.Common}/${AssetsDirectory.Casino}`;
    let extention;

    if (runtimeConfig.SITE_CONFIG.layouts._casino.type === CasinoLayoutEnum.Compact) {
        extention = tags.includes(CasinoGameTag.VFX) ? "mp4" : "webp";

        if (CasinoScopesMap.slots.includes(gameType as CasinoGameTypeEnum)) {
            dir += `/${AssetsDirectory.SlotGames}`;
        } else {
            dir += `/${AssetsDirectory.LiveCasinoGames}`;
        }

        if (options?.folder) {
            dir += `/${options.folder}`;
        }

        if (options?.showVideo) {
            if (options.imgVariant) {
                gameImgId += `_${options.imgVariant}`;
            }
            extention = "mp4";
        }

        if (tags.includes(CasinoGameTag.CGFX)) {
            gameImgId = `cgfx_${gameImgId}`;
        }
    }

    return `${dir}/${gameImgId}${
        options?.useAppName
            ? `_${formatAppNameText(runtimeConfig.COMMON_SITE_CONFIGS.appName)}`
            : ""
    }.${extention}`;
};

export const getReelThumbnailSrc = (
    hrefBehavior: HrefBehavior,
    gameId: string,
    runtimeConfig: IRuntimeConfig,
) => {
    const isGame = (href_behavior: HrefBehavior) =>
        [HrefBehavior.GameSlot, HrefBehavior.GameLiveCasino].includes(href_behavior);

    const isLink = (href_behavior: HrefBehavior) =>
        [HrefBehavior.External, HrefBehavior.Relative].includes(href_behavior);

    const isSlots = (href_behavior: HrefBehavior) => href_behavior === HrefBehavior.GameSlot;

    if (isGame(hrefBehavior) && gameId) {
        return getCasinoGameImgSrc(
            runtimeConfig,
            gameId,
            isSlots(hrefBehavior) ? CasinoGameTypeEnum.VIDEO_SLOTS : CasinoGameTypeEnum.LIVE_CASINO,
            [],
        );
    } else if (isLink(hrefBehavior)) {
        return `/${formatAppNameText(
            runtimeConfig.COMMON_SITE_CONFIGS.appName,
        )}/${AssetsDirectory.Common}/favicon.ico`;
    }
    return "";
};
